import React, { FC } from 'react';
import { TextField, Grid, FormControlLabel, Switch, FormGroup, Box } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import Swal from 'sweetalert2';
import { useTranslation } from 'react-i18next';
import { SCUIButton } from '../../../atomic/atoms';
import { OrderCommand } from '../../../services/command';
import { SCRN } from '../shippingCancelReason.classes';
interface IProps {
    selectedRow?: any;
    onClose?: any;
    refresh?: any;
}
export const SCUIShippingCancelReasonUpdateDrawer: FC<IProps> = ({ selectedRow, onClose, refresh }) => {
    const handleChangeSwitch = (event?: any) => {
        setIsActive(event.target.checked);
    };
    const UpdateShippingReason = async () => {
        console.info(selectedRow);
        let reqArray = [];
        let params = {
            reasonId: selectedRow?.reasonId,
            reasonKey: reasonKey,
            isActive: isActive,
            priorityId: priortyId,
        };
        reqArray.push(params);
        if (reasonKey && reasonKey?.trim().length > 0) {
            OrderCommand.UpdateShippingListCancelReason({ Reasons: reqArray })
                .then((res: any) => {
                    if (res.isSuccess) {
                        Swal.fire(t('general.updated'), ' ', 'success');
                    } else {
                        Swal.fire(t('general.error'), ' ', 'error');
                    }
                })
                .catch((error: any) => {
                    Swal.fire(t('general.error'), ' ', 'error');
                    console.log('Hata :>> ', error);
                })
                .finally(() => {
                    refresh();
                    onClose();
                });
        } else {
            Swal.fire(t('mobilePanel.noEmpty'), ' ', 'error');
        }
    };
    const InsertShippingReason = async () => {
        console.info(selectedRow);
        let params = {
            reasonKey: reasonKey,
        };
        if (reasonKey && reasonKey?.trim().length > 0) {
            OrderCommand.InsertShippingListCancelReasons(params).then(() => {
                Swal.fire(t('general.added'), ' ', 'success');
                refresh();
                onClose();
            });
        } else {
            Swal.fire(t('mobilePanel.noEmpty'), ' ', 'error');
        }
    };
    const { t } = useTranslation();
    const [reasonKey, setReasonKey] = React.useState(selectedRow?.reasonKey);
    const [priortyId, setPriortyId] = React.useState(selectedRow?.reasonPriorityId);
    const [isActive, setIsActive] = React.useState(selectedRow?.isActive);
    const isEdit = selectedRow?.reasonKey?.length > 0;
    return (
        <Box sx={{ padding: '24px 16px' }} className={SCRN.drawerRoot} data-reason-id={selectedRow?.reasonId}>
            <Grid container sx={{ padding: '1rem' }} className={SCRN.drawerHeader}>
                <Grid
                    className={SCRN.drawerTitleBox}
                    size={{
                        md: 6,
                        xs: 6,
                        lg: 11,
                    }}
                >
                    <h1 className={`headtxt ${SCRN.drawerTitle}`}>
                        {isEdit ? t('general.edit') : t('general.add')}
                    </h1>
                </Grid>

                <Grid
                    className={SCRN.drawerCloseBox}
                    size={{
                        md: 1,
                        xs: 1,
                        lg: 1,
                    }}
                >
                    <CloseIcon className={`svg_icons ${SCRN.btnDrawerClose}`} onClick={onClose} />
                </Grid>
            </Grid>
            {selectedRow.length !== 0 ? (
                <Grid container spacing={2} sx={{ padding: '1rem' }} className={SCRN.drawerForm}>
                    <Grid
                        className={SCRN.drawerFieldReasonId}
                        size={{
                            md: 12,
                            xs: 12,
                        }}
                    >
                        <TextField
                            className={SCRN.inputDrawerReasonId}
                            label="Reason Id"
                            margin="dense"
                            id="parameterValue"
                            fullWidth
                            defaultValue={selectedRow?.reasonId}
                            disabled
                        />
                    </Grid>
                    <Grid
                        className={SCRN.drawerFieldReasonKey}
                        size={{
                            md: 12,
                            xs: 12,
                        }}
                    >
                        <TextField
                            className={SCRN.inputDrawerReasonKey}
                            label="Reason Key"
                            margin="dense"
                            id="parameterValue"
                            fullWidth
                            defaultValue={selectedRow?.reasonKey}
                            onChange={(e: any) => {
                                setReasonKey(e.target.value);
                            }}
                        />
                    </Grid>
                    <Grid
                        className={SCRN.drawerFieldPriority}
                        size={{
                            md: 12,
                            xs: 12,
                        }}
                    >
                        <TextField
                            className={SCRN.inputDrawerPriority}
                            label={t('shippingCancelReason.reasonPriorityId')}
                            margin="dense"
                            id="parameterValue"
                            fullWidth
                            defaultValue={selectedRow?.reasonPriorityId}
                            type={'number'}
                            onChange={(e: any) => {
                                setPriortyId(e.target.value);
                            }}
                        />
                        <FormGroup className={SCRN.drawerActiveGroup}>
                            <FormControlLabel
                                className={SCRN.inputDrawerIsActiveLabel}
                                control={
                                    <Switch
                                        className={SCRN.inputDrawerIsActive}
                                        checked={isActive}
                                        onChange={handleChangeSwitch}
                                        data-reason-id={selectedRow?.reasonId}
                                        data-is-active={String(!!isActive)}
                                    />
                                }
                                label={t('general.active')}
                            />
                        </FormGroup>
                    </Grid>
                </Grid>
            ) : (
                <Grid
                    className={SCRN.drawerInsertForm}
                    size={{
                        md: 12,
                        xs: 12,
                    }}
                >
                    <Grid className={SCRN.drawerFieldInsertReasonKey}>
                        <TextField
                            className={SCRN.inputDrawerInsertReasonKey}
                            label="Reason Key"
                            margin="dense"
                            id="parameterValue"
                            fullWidth
                            defaultValue={selectedRow?.reasonKey}
                            onChange={(e: any) => {
                                setReasonKey(e.target.value);
                            }}
                        />
                    </Grid>
                </Grid>
            )}
            <Grid container justifyContent="flex-end" className={SCRN.drawerActions}>
                <SCUIButton
                    className={`${SCRN.btnDrawerSubmit} ${isEdit ? SCRN.btnDrawerSubmitUpdate : SCRN.btnDrawerSubmitInsert}`}
                    text={isEdit ? t('general.update') : t('general.add')}
                    type="primary"
                    sizeType="fixed"
                    size={'m'}
                    buttonType="button"
                    onClick={isEdit ? UpdateShippingReason : InsertShippingReason}
                />
            </Grid>
        </Box>
    );
};
